var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row p-4" },
    [
      _c(
        "div",
        { staticClass: "col-12 col-md-6" },
        [
          _c("h4", [
            _c("b", [_vm._v("Total de encuestas:")]),
            _vm._v(" " + _vm._s(_vm.declaration.total)),
          ]),
          _vm._v(" "),
          _c("apexchart", {
            attrs: {
              type: "bar",
              height: "350",
              options: _vm.chartOptions,
              series: _vm.declaration.grafico.series,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.declaration.indicadores, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "col-12 col-md-3" },
          [_c("ListaIndicadores", { attrs: { declaration: item } })],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }